import { render, staticRenderFns } from "./ArticleA.vue?vue&type=template&id=1fd7875a&scoped=true"
import script from "./ArticleA.vue?vue&type=script&lang=js"
export * from "./ArticleA.vue?vue&type=script&lang=js"
import style0 from "./ArticleA.vue?vue&type=style&index=0&id=1fd7875a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fd7875a",
  null
  
)

export default component.exports